/**
 * return 000-00-00000 || 000-00-*****
 * @param value, mask
 */
export default (value: string, mask?: boolean) => {
  if(!value || String(value).length !== 10) {
    return value
  }
  let formatNum: string = ''
  if(mask) {
    formatNum = value.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-*****')
  } else {
    formatNum = value.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
  }
  return formatNum
}
